import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { orderBy as _orderBy } from 'lodash-es';

import { API_STATUS } from 'store/constants';
import { fetchAssessments, fetchAssessmentDetails, addUserAssessment } from './assessmentsAPI';


const initialState = {
	status: API_STATUS.CLEAR,
	fetchAssessmentDetails: API_STATUS.CLEAR,
	assessmentList: {}
};


export const getAssessmentsAsync = createAsyncThunk('assessments/fetchAssessments', async () => {
	const assessmentsResponse = await fetchAssessments();
	const mappedSessions = (assessmentsResponse || []).map(assessment => ({
		...assessment,
		modifiedAt: new Date(assessment.modifiedDate).getTime()
	}));
	const assessments = _orderBy(mappedSessions, 'modifiedAt');

	return { assessments };
});


export const getAssessmentDetailsAsync = createAsyncThunk('assessments/fetchAssessmentDetails', async assessmentId => {
	const assessmentDetails = await fetchAssessmentDetails(assessmentId);
	return { ...assessmentDetails };
});


export const addUserAssessmentAsync = createAsyncThunk('assessments/addUserAssessment', async (payload) => {
	const userAssessment = await addUserAssessment(payload);
	return { userAssessment };
});


const assessmentsSlice = createSlice({
	name: 'assessments',
	initialState,
	reducers: {
		setAssessments: (state, action) => {
			state.assessmentList = action.payload.assessments;
			state.loaded = true;
		}
	},
	extraReducers: builder => {
		builder
			.addCase(getAssessmentsAsync.fulfilled, (state, action) => {
				state.assessmentList = action.payload.assessments;
				state.status = API_STATUS.COMPLETED;
				state.loaded = true;
			})
			.addCase(getAssessmentsAsync.rejected, state => {
				state.status = API_STATUS.REJECTED;
			})
			.addCase(getAssessmentDetailsAsync.fulfilled, (state, action) => {
				state.assessmentList[action.payload.assessmentId] = action.payload;
				state.fetchAssessmentDetails = API_STATUS.COMPLETED;
			})
			.addCase(getAssessmentDetailsAsync.rejected, state => {
				state.fetchAssessmentDetails = API_STATUS.REJECTED;
			})
			.addCase(addUserAssessmentAsync.fulfilled, (state, action) => {
				//state.userAssessmentList.push(action.payload.event);
				state.eventAdded = API_STATUS.COMPLETED;
			})
			.addCase(addUserAssessmentAsync.rejected, state => {
				state.eventAdded = API_STATUS.REJECTED;
			})
	}
});

export const selectAssessmentsLoaded = state => state.assessments.loaded;

export const selectAssessmentsList = state => state.assessments.assessmentList;

export const selectAssessmentDetails = assessmentId => state => state.assessments.assessmentList[assessmentId];

export const selectAssessmentQuestions = assessmentId => state => state.assessments.assessmentList[assessmentId]?.questions || [];

export const { setAssessments } = assessmentsSlice.actions;

export default assessmentsSlice.reducer;
